import {
  ToolIconFrame,
  toolIconPrimary,
  toolIconSecondary,
  type ToolIconProps
} from './ToolIconFrame';

export function KeywordResearchIcon(props: ToolIconProps) {
  return (
    <ToolIconFrame {...props}>
      <circle
        cx="21"
        cy="21"
        r="15.5"
        fill="none"
        stroke={toolIconPrimary}
        strokeWidth="3.2"
      />
      <path
        d="m33.5 32.5 8 8"
        fill="none"
        stroke={toolIconPrimary}
        strokeWidth="5.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="m19.394 13.5-3.188 15m9.588-15-3.188 15M14.18 17.8h15m-16.36 6.4h15"
        fill="none"
        stroke={toolIconSecondary}
        strokeWidth="2.52"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </ToolIconFrame>
  );
}
